module.exports = __webpack_public_path__ + "assets/img/rankBg.c6c772f7.png";